import _ from "underscore";
import vars from "@exo/narrative-tracker-variables";

import { SETUP_TOPIC_STATS } from "actions/constants.js";

import { fetchTimeseriesInit } from "actions/timeseries.js"; // not a real fetch
// import { fetchTopicStats } from "actions/fetch";

import projectConfig from "config/projectConfig.js";
import { markFilters } from "lib/helpers/filterHelpers.js";
import { log } from "lib/helpers/helpers.js";
import { addColorToNestedArray, colors, leftColors, rightColors } from "lib/color.js";

// import mockTrends from "lib/mockData/mock30Trends.js";
import mockEventTypes from "lib/mockData/eventTypes.js";

export function evaluateInput(text) {
	return {
		type: "evaluateInput",
		text,
	};
}
// NOTE: this is for the tag system, from the narratives tab, which is not currently in use
// // Inits submit tags UI feedback and dispatches fetch to Kibana
// // This action is called when adding a new tag or editing an existing one.
// //    editingTrend: string. The id of the trend to remove
// export function submitTags(
// 	tags1,
// 	tags2,
// 	baseTrend,
// 	locations,
// 	outlets,
// 	people,
// 	companies,
// 	topics,
// 	sourceLocations,
// 	sourceTypes,
// 	editingTrend
// ) {
// 	return (dispatch) => {
// 		dispatch(submitTagsInit());
// 		const queryString = makeQueryString(tags1, tags2, globalFilters);
// 		console.log("QUERY STRING --> ", queryString);
// 		console.log(baseTrend);
// 		const publishDateGreaterThan = baseTrend.rangeStart;
// 		const publishDateLessThan = baseTrend.rangeEnd;

// 		// This needs to be saved with the results for editing.
// 		//    parsing a query string with filters doesn't work now, so we need to parse
// 		//    the original input.
// 		const queryArguments = {
// 			tags: tags2 ? [...tags1, ...tags2] : tags1,
// 			locations,
// 			outlets,
// 			people,
// 			companies,
// 			topics,
// 			sourceLocations,
// 			sourceTypes,
// 		};
// 		console.log("query", queryArguments);
// 		// return fetch(api.narratives, api.optionsForGET)
// 		//   .then(response => response.json())
// 		//   .then(json =>
// 		//     dispatch(receiveTrends(json))
// 		//   )
// 		//   .catch((error) => {
// 		//     console.error(error);
// 		//   });
// 	};
// }
// // Will close & clear modal and start spinner
// export function submitTagsInit() {
// 	return {
// 		type: "submitTags",
// 	};
// }
// export function addTags() {
// 	return {
// 		type: "addTags",
// 	};
// }
// export function deleteTag(id) {
// 	return {
// 		type: "deleteTag",
// 		id,
// 	};
// }
// export function clearTags() {
// 	return {
// 		type: "clearTags",
// 	};
// }
// export function setTagFilter(tag, filter) {
// 	return {
// 		type: "setTagFilter",
// 		tag,
// 		filter,
// 	};
// }
// export function setTagFilterAll(tag, filter) {
// 	return {
// 		type: "setTagFilterAll",
// 		tag,
// 		filter,
// 	};
// }

// dispatch the follow up fetches once the trends info is available
// sharedActiveNarrativeData: false or object. Only exists if loading from a shared URL link
export function receiveTrends(params) {
	// log(["(trends.js 113) receiveTrends", params]);
	const { json, noInit, sharedActiveNarrativeData } = params;

	const narratives = _.find(json, (data) => {
		return data.id === "narratives";
	});
	return (dispatch, getState) => {
		const { currentProject } = getState().login;

		// dispatch(receiveTrendsNow(mockTrends));
		dispatch(receiveTrendsNow({ json, currentProject, sharedActiveNarrativeData, narratives }));
		dispatch({ type: "initVarStore" });
		if (!noInit) {
			// TODO: refactor to do both of these inside data.js FLAG_REFACTOR_DATA_JS
			dispatch(fetchTimeseriesInit(narratives, "Source")); // timeseries dependent inits happen in the response
			// dispatch(fetchStats()); // Should probably happen in fetchTimeseriesInit

			if (projectConfig[currentProject] && projectConfig[currentProject].topicsPie && projectConfig[currentProject].topicStatsConfig) {
				const { topicStatsConfig } = projectConfig[currentProject];
				const allChildren = [];
				_.each(topicStatsConfig, (topic) => {
					_.each(topic.children, (child) => {
						allChildren.push(child);
					});
				});
				dispatch({ type: SETUP_TOPIC_STATS, topicStatsConfig, expectedNarratives: allChildren.length });
			}
		}
	};
}

// receive narratives
export function receiveTrendsNow(params) {
	const { json, currentProject, sharedActiveNarrativeData, narratives } = params;
	// log(["(trends.js 150) receiveTrendsNow ", currentProject, json, sharedActiveNarrativeData]);

	let sourceFilters = _.find(json, (data) => {
		return data && data.id === "sourceInfo";
	});
	sourceFilters = sourceFilters ? sourceFilters.children : [];
	sourceFilters = markFilters({ filters: sourceFilters, value: "Source" });
	let audienceFilters = _.find(json, (data) => {
		return data && data.id === "audienceInfo";
	});
	audienceFilters = audienceFilters ? audienceFilters.children : [];
	audienceFilters = markFilters({ filters: audienceFilters, value: "Audience" });
	const moe = _.find(json, (data) => {
		return data && data.id === "moe";
	});
	const searches = _.find(json, (data) => {
		return data && data.id === "additionalSearches";
	});
	const aiSupport = _.find(json, (data) => {
		return data && data.id === "languageSupport";
	});

	// log(["(trends.js 191) narratives", narratives]);

	// const aiSupport = {
	// 	f74be09bbb82f509f1db2a80d47893d1: ["Russian"],
	// 	e43e12d8912996b268a1f3f2bcb93d10: ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	d81b318ef64aba89353d802dac87d03b: ["Russian", "Lithuanian"],
	// 	d483216742b1e6afb9aed78b74428f1d: ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	b882f61c87f8b5a5375f51a7b9de5838: ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	b6b52fefeb089f386ce6a1dc57e0a0e1: ["Russian", "Romanian", "Lithuanian", "Latvian", "Estonian"],
	// 	b5a22c0ca1fd162707afaaf41acec38c: ["Russian"],
	// 	a72458bcbf931b2719393869b1176c43: ["Russian", "Lithuanian", "Estonian"],
	// 	a6c3037a42df3f8786ec9e42552aa01f: ["Russian", "Romanian", "Lithuanian", "Latvian", "Estonian"],
	// 	"9b3cb8663cdccc46eb71b2fb61576cf2": ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	"7e4bc4ab4458e7b66419c8eb78f76c36": ["Russian"],
	// 	"7e0000e78734198de2c43e029ad0e942": ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	"651eb4ffebe2cd4c885984439a20d226": ["Russian"],
	// 	"536087d2e53af6790846fbe48b598c1b": ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	"2fe98880d219b34ec658cc13e39f8fea": [
	// 		"Russian",
	// 		"Romanian",
	// 		"Lithuanian",
	// 		"Latvian",
	// 		"Estonian",
	// 	],
	// 	"2f64b59537094a643296233b15dda61d": ["Russian", "Lithuanian", "Latvian", "Estonian"],
	// 	"2d7d59c8cdda3d2bda471aca44863d78": ["Russian", "Romanian", "Lithuanian", "Estonian"],
	// 	"289796dce16e28e1709def63e824be38": [
	// 		"Russian",
	// 		"Romanian",
	// 		"Lithuanian",
	// 		"Latvian",
	// 		"Estonian",
	// 	],
	// 	"0cbbb6360267cbf4ddfdeb6701236d10": [
	// 		"Russian",
	// 		"Romanian",
	// 		"Lithuanian",
	// 		"Latvian",
	// 		"Estonian",
	// 	],
	// 	"07ffa8cc2364642064242a6fdd012dbe": ["Russian"],
	// 	"01d6cc9a080ee04b6a470c3c17899faa": [
	// 		"Russian",
	// 		"Romanian",
	// 		"Lithuanian",
	// 		"Latvian",
	// 		"Estonian",
	// 	],
	// 	b41bb5b4f47a777e09df7526d1c80eef: ["Estonian"],
	// };

	const subNarrativesExist =
		narratives &&
		_.find(narratives.children, (nar) => {
			return nar.children;
		});

	// console.log("narratives", narratives);
	// console.log("sourceFilters", sourceFilters);
	// console.log("audienceFilters", audienceFilters);
	// console.log("moe", moe);
	// console.log("searches", searches);

	// // TODO: remove this when API has been updated
	// moe.children[0].color.dark = "#dbb923";
	// moe.children[0].name = "Campaign Spending";

	return (dispatch) => {
		// console.log("updated narratvies", narratives);

		// Reduce the topics' weight. Topics should always appear first
		_.each(narratives.children, (topic, index) => {
			topic.weight = typeof topic.weight === "number" ? topic.weight - 100 : index - 100;
		});

		// Overriding colors for now
		narratives.color = {
			dark: "#accaf2", // sky-2
			light: "#2462b8", // exoveraBlue
			colorblind: false,
		};

		// Adjust base narrative name
		narratives.name =
			narratives.children[0] && narratives.children[0].children && narratives.children[0].children.length > 0
				? "All Topics"
				: "All Narratives";
		narratives.parent = "self";

		const { overrideColors, overrideColorsGently } = projectConfig[currentProject];

		// basic color theme hack
		if (overrideColors || overrideColorsGently) {
			narratives.children = addColorToNestedArray({
				array: narratives.children,
				childName: "children",
				sortBy: "weight",
				gently: overrideColorsGently,
			});
			narratives.searches = addColorToNestedArray({
				array: narratives.searches,
				childName: "children",
				sortBy: "weight",
				gently: overrideColorsGently,
			});
		}

		// console.log(">>>>>>", narratives);
		// HACK: Russia is red
		const red1 = {
			// 0
			id: "red",
			dark: "#d82555", // coral
			// dark: "#f2594e", // coral
			light: "#e01d07", // bright red
			// light: "#c02e1d", // red
			colorblind: "colorblindTiny",
		};
		const red2 = {
			// 0
			id: "orangeRed",
			// dark: "#f2594e", // coral
			dark: "#d85b25", // orange red
			// dark: "#cc0000", // red
			// dark: "#c02e1d", // red
			light: "#eb6e34", // orange red
			colorblind: "colorblindBroken",
		};
		const red3 = {
			// 0
			id: "fuschia",
			dark: "#a30f45", // fuschia
			light: "#a30f45", // fuschia
			colorblind: "colorblindDots",
		};
		const green = {
			// 4
			id: "grass",
			dark: "#32C402", // grass
			light: "#007005", // Green
			colorblind: "colorblindTinyDots",
		};
		if (currentProject === "gec" || currentProject === "gec_analyst") {
			// Russia
			if (narratives.children[0].children) {
				narratives.children[0].children[0].color = red3;
				narratives.children[0].children[1].color = red1;
				narratives.children[0].children[2].color = red2;
				narratives.children[0].children[3].color = colors[2];
				narratives.children[0].children[4].color = colors[0];
			}
			// Governance
			if (narratives.children[1].children) {
				narratives.children[1].children[0].color = red1;
				narratives.children[1].children[1].color = colors[0];
			}
			// The West
			if (narratives.children[2].children) {
				narratives.children[2].children[0].color = red2;
				narratives.children[2].children[1].color = red3;
				narratives.children[2].children[2].color = red1;
				narratives.children[2].children[3].color = colors[1];
				narratives.children[2].children[4].color = colors[0];
			}
			// Nationalism
			if (narratives.children[3].children) {
				narratives.children[3].children[0].color = red1;
				narratives.children[3].children[1].color = colors[1];
			}
			// NATO
			if (narratives.children[4].children) {
				narratives.children[4].children[0].color = red1;
				narratives.children[4].children[1].color = red2;
				narratives.children[4].children[2].color = colors[1];
			}
		}

		// if (currentProject === "politics2020") {
		// 	// Economy
		// 	if (narratives.children[8].children) {
		// 		narratives.children[8].children[0].color = green;
		// 		// narratives.children[8].children[1].color = colors[1];
		// 		narratives.children[8].children[2].color = red2;
		// 	}
		// }

		// HACK: China is red
		if (currentProject === "mf" || currentProject === "mf_translate") {
			// DPP con
			narratives.children[0].color = red1;
			// KMT pro
			narratives.children[3].color = red3;
		}

		// HACK: NEST hacky hackeroo
		if (currentProject === "nest" || currentProject === "nest_mongolia") {
			const { right1, right2, right5 } = rightColors;
			const { left1, left2, left4 } = leftColors;
			// // ------- Colorful -------
			// // Anti CCP
			// if (narratives.children[0]) {
			// 	narratives.children[0].color = colors[0];
			// }
			// // Pro CCP
			// if (narratives.children[1]) {
			// 	narratives.children[1].color = colors[1];
			// }
			// // Anti US
			// if (narratives.children[3]) {
			// 	narratives.children[3].color = colors[4];
			// }
			// // Pro US
			// if (narratives.children[2]) {
			// 	narratives.children[2].color = colors[3];
			// }
			// // Anti Kremlin
			// if (narratives.children[4]) {
			// 	narratives.children[4].color = colors[7];
			// }
			// // Pro Kremlin
			// if (narratives.children[5]) {
			// 	narratives.children[5].color = colors[8];
			// }
			// ------- All the same -------
			// Anti CCP
			if (narratives.children[0]) {
				narratives.children[0].color = left2;
			}
			// Pro CCP
			if (narratives.children[1]) {
				narratives.children[1].color = right1;
			}
			// Pro US
			if (narratives.children[2]) {
				narratives.children[2].color = left2;
			}
			// Anti US
			if (narratives.children[3]) {
				narratives.children[3].color = right1;
			}
			// Anti Kremlin
			if (narratives.children[4]) {
				narratives.children[4].color = left2;
			}
			// Pro Kremlin
			if (narratives.children[5]) {
				narratives.children[5].color = right1;
			}
			// ------- Red/Blue -------
			// // Anti CCP
			// if (narratives.children[0]) {
			// 	narratives.children[0].color = left1;
			// }
			// // Pro CCP
			// if (narratives.children[1]) {
			// 	narratives.children[1].color = right2;
			// }
			// // Pro US
			// if (narratives.children[2]) {
			// 	narratives.children[2].color = left2;
			// }
			// // Anti US
			// if (narratives.children[3]) {
			// 	narratives.children[3].color = right1;
			// }
			// // Anti Kremlin
			// if (narratives.children[4]) {
			// 	narratives.children[4].color = left4;
			// }
			// // Pro Kremlin
			// if (narratives.children[5]) {
			// 	narratives.children[5].color = right5;
			// }
		}

		// // Iraq hack
		// if (currentProject === "iraq") {
		// 	if (narratives.children[0]) {
		// 		narratives.children[0].name = "PM Abadi is a unifier";
		// 		narratives.children[0].info = [
		// 			"PM Abadi reunified the country when he defeated ISIS and regained Kirkuk",
		// 			"PM Abadi is an educated and practical leader capable of rebuilding Iraq",
		// 			"PM Abadi keeps the country from Iranian control",
		// 			"U.S.would support PM Abadi to reduce the influence of pro - Iran militias",
		// 			"PM Abadi will now take the fight against corruption",
		// 			"PM Abadi has brought Iraq back into the fold of the international community",
		// 			"PM Abadi is creating the right atmosphere for investment",
		// 		];
		// 	}
		// 	if (narratives.children[1]) {
		// 		narratives.children[1].name = "PM Abadi now fights corruption";
		// 	}
		// 	if (narratives.children[3]) {
		// 		narratives.children[3].name = "Poverty and unemployment rates have increased";
		// 		narratives.children[3].info = [
		// 			"PM Abadi will hand the country over to the PMF",
		// 			"PM Abadi is a U.S.puppet and sells out Iraq to the U.S.to stay in power",
		// 			"PM Abadi lacks the strength to fight corruption",
		// 			"Poverty and unemployment rates in the country have increased",
		// 		];
		// 	}
		// 	if (narratives.children[4]) {
		// 		narratives.children[4].name = "The government is too close to the US";
		// 	}
		// }

		// // // Texas 23rd Info hack
		// if (currentProject === "texas23") {
		// 	if (narratives.children[0]) {
		// 		// narratives.children[0].name = "Trump doing good things for US";
		// 		narratives.children[0].header = "Trump";
		// 		narratives.children[0].info = [
		// 			{
		// 				header: "Supporting Narratives",
		// 				bullets: [
		// 					'KEY NARRATIVE: "Trump doing good things for America (even if not my preferred president)."',
		// 					"Trump is strong & stands up for America (“America First”)",
		// 					"Trump is successful & stands up against establishment (non-politician shaking up the system ruining america)",
		// 					'Trump plays "12D Chess" (outmaneuvering rivals & MAGA)',
		// 				],
		// 			},
		// 			{
		// 				header: "Opposing Narratives",
		// 				bullets: [
		// 					"Trump is dishonest and his family/associates are corrupt",
		// 					"Trump is untethered & “dangerous” (unqualified/impulsive)",
		// 					"Trump is a “bigot” (ethnic nationalist/sexist)",
		// 				],
		// 			},
		// 		];
		// 	}

		// 	if (narratives.children[1]) {
		// 		narratives.children[1].header = "Tax Reform (December 2017 tax bill)";
		// 		narratives.children[1].info = [
		// 			{
		// 				header: "Supporting Narratives",
		// 				bullets: [
		// 					'KEY NARRATIVE: "Tax reform is good for workers/normal Texans." (i.e. individuals, not just general economy)',
		// 					"Reform boosts the economy--keeps money in productive business’ & workers’ hands (taxes stifle economy/job creation)",
		// 					"Tax cuts reward hard work & success (taxes penalize these)",
		// 					"Reforms starve Washington machine, reduce freeloading & corruption (taxes feed Tammany Hall politics)",
		// 				],
		// 			},
		// 			{
		// 				header: "Opposing Narratives",
		// 				bullets: [
		// 					"Tax breaks primarily benefit the rich, who make the rules",
		// 					"Normal people are being squeezed by a consolidation of wealth",
		// 					"Tax cut disproportionate to loss of services & deficit increase",
		// 				],
		// 			},
		// 		];
		// 	}
		// 	if (narratives.children[2]) {
		// 		narratives.children[2].header = "DACA";
		// 		narratives.children[2].info = [
		// 			{
		// 				header: "Supporting Narratives",
		// 				bullets: [
		// 					"Dreamers are innocent - victims of parents/bad policy",
		// 					"Dreamers are Americans",
		// 					"Dreamers are productive contributors to the economy",
		// 				],
		// 			},
		// 			{
		// 				header: "Opposing Narratives",
		// 				bullets: [
		// 					'KEY NARRATIVE: "Dream Act is a bandaid, need comprehensive immigration reform"',
		// 					"DACA encourages illegal immigration & undermine rule of law",
		// 					"Dreamers are freeloaders who cost jobs/resources",
		// 				],
		// 			},
		// 		];
		// 	}
		// 	if (narratives.children[3]) {
		// 		narratives.children[3].header = "Border Security & Immigration";
		// 		narratives.children[3].info = [
		// 			{
		// 				header: "Supporting Narratives",
		// 				bullets: [
		// 					'KEY NARRATIVE: "Ineffective border enforcement is a crisis threatening our communities, law & order"',
		// 					"Open borders make us less safe, we have a right to defend ourselves",
		// 					"Illegal immigrants are dangerous",
		// 					"Criminals are taking advantage of porous border - needs physical barrier",
		// 				],
		// 			},
		// 			{
		// 				header: "Opposing Narratives",
		// 				bullets: [
		// 					"Border security is ineffective & wastes money (Wall is impractical)",
		// 					"Immigrants are actually good for the US",
		// 					"Border security is discriminatory & sometimes inhumane",
		// 				],
		// 			},
		// 		];
		// 	}
		// 	if (narratives.children[4]) {
		// 		narratives.children[4].header = "Trade Protection";
		// 		narratives.children[4].info = [
		// 			{
		// 				header: "Supporting Narratives",
		// 				bullets: [
		// 					"Other countries taking advantage of the US (via bad deals, lax standards/slave labor)",
		// 					"Trade is bad for workers as it costs US jobs (giant sucking sound)",
		// 					"Trade only benefits rich elites",
		// 				],
		// 			},
		// 			{
		// 				header: "Opposing Narratives",
		// 				bullets: [
		// 					'KEY NARRATIVE: "Trade protection harms the economy & ultimately hurts workers"',
		// 					"Trade/NAFTA is good for the economy (rising tide benefits TX23)",
		// 					"US producers benefit from selling to markets abroad",
		// 				],
		// 			},
		// 		];
		// 	}

		// 	// Other trends info hack
		// 	if (narratives.children[5]) {
		// 		narratives.children[5].header = "Keyword search for Texas politicians";
		// 		narratives.children[5].info = [];
		// 	}
		// 	if (narratives.children[6]) {
		// 		narratives.children[6].header = "Keyword search for Will Hurd";
		// 		narratives.children[6].info = [];
		// 	}
		// 	if (narratives.children[7]) {
		// 		narratives.children[7].header = "Keyword search for Gina Ortiz";
		// 		narratives.children[7].info = [];
		// 	}
		// 	if (narratives.children[8]) {
		// 		narratives.children[8].header = "Keyword search for John Cornyn";
		// 		narratives.children[8].info = [];
		// 	}
		// 	if (narratives.children[9]) {
		// 		narratives.children[9].header = "Keyword search for Ted Cruz";
		// 		narratives.children[9].info = [];
		// 	}
		// 	if (narratives.children[10]) {
		// 		narratives.children[10].header = "Keyword search for Beto O'Rourke";
		// 		narratives.children[10].info = [];
		// 	}
		// 	if (narratives.children[11]) {
		// 		narratives.children[11].header = "Keyword search for Greg Abbott";
		// 		narratives.children[11].info = [];
		// 	}
		// }

		// // Save trend order. Some functions alter the order
		// _.each(narratives.children, (trend, index) => {
		// 	narratives.children[index].order = index;
		// 	if (trend.children && trend.children.length > 0) {
		// 		_.each(trend.children, (kidTrend, kidIndex) => {
		// 			// the child order must always be higher than their parent's
		// 			narratives.children[index].children[kidIndex].order =
		// 				kidIndex + narratives.children.length + 1;
		// 		});
		// 	}
		// });
		// narratives.order = -1;

		// 720 color override
		// Overriding colors for now
		if (
			currentProject === "sevenTwenty" ||
			currentProject === "sevenTwenty_uscc" ||
			currentProject === "bcbs" ||
			currentProject === "midterms" ||
			currentProject === "dccc"
		) {
			if (narratives.children[0]) {
				narratives.children[0].color.dark = "#0c77f4"; // blue
				narratives.children[0].color.light = "#0c77f4"; // blue
				narratives.children[0].color.colorblind = "colorblindDashed";
			}
			if (narratives.children[1]) {
				narratives.children[1].color.dark = "#417505"; // Green
				narratives.children[1].color.light = "#417505"; // Green
				narratives.children[1].color.colorblind = "colorblindBroken";
			}
			if (narratives.children[2]) {
				narratives.children[2].color.dark = "#0591a3"; // Teal
				narratives.children[2].color.light = "#0591a3"; // Teal
				narratives.children[2].color.colorblind = false;
			}
			if (narratives.children[3]) {
				narratives.children[3].color.dark = "#e99a27"; // Gold
				narratives.children[3].color.light = "#e99a27"; // Gold
				narratives.children[3].color.colorblind = "colorblindDots"; // chartreuse
			}
			if (narratives.children[4]) {
				narratives.children[4].color.dark = "#f4cc94"; // Light Gold
				narratives.children[4].color.light = "#f4cc94"; // Light Gold
				narratives.children[4].color.colorblind = "colorblindTinyDots";
			}
		}

		// HACK: Left/Right suppoting narratives hack
		if (currentProject === "politics2020") {
			const { right1, right2, right3, right4, right5 } = rightColors;
			const { left1, left2, left3, left4, left5, left6 } = leftColors;
			// President Trump
			if (narratives.children[0]) {
				narratives.children[0].color = right1;
				// "Crooked"
				if (narratives.children[0].children[0]) {
					narratives.children[0].children[0].color = left1;
				}
				// "Discriminatory"
				if (narratives.children[0].children[1]) {
					narratives.children[0].children[1].color = left2;
				}
				// "Dangerous"
				if (narratives.children[0].children[2]) {
					narratives.children[0].children[2].color = left3;
				}
				// "Bad Policy"
				if (narratives.children[0].children[3]) {
					narratives.children[0].children[3].color = left4;
				}
				// "Doing good things"
				if (narratives.children[0].children[4]) {
					narratives.children[0].children[4].color = right3;
				}
				// "Stands up for America"
				if (narratives.children[0].children[5]) {
					narratives.children[0].children[5].color = right4;
				}
				// "Rights establishment"
				if (narratives.children[0].children[6]) {
					narratives.children[0].children[6].color = right2;
				}
			}
			// Joe Biden
			if (narratives.children[1]) {
				narratives.children[1].color = left2;
				// "Moving US forward"
				if (narratives.children[1].children[0]) {
					narratives.children[1].children[0].color = left6;
				}
				// "Unifier"
				if (narratives.children[1].children[1]) {
					narratives.children[1].children[1].color = left1;
				}
				// "Experienced and competent"
				if (narratives.children[1].children[2]) {
					narratives.children[1].children[2].color = left5;
				}
				// "Uncle Joe"
				if (narratives.children[1].children[3]) {
					narratives.children[1].children[3].color = left3;
				}
				// "Not Trump"
				if (narratives.children[1].children[4]) {
					narratives.children[1].children[4].color = left4;
				}
				// "Socialist"
				if (narratives.children[1].children[5]) {
					narratives.children[1].children[5].color = right1;
				}
				// "Too establishment"
				if (narratives.children[1].children[6]) {
					narratives.children[1].children[6].color = right2;
				}
				// "Dihonest or corrupt"
				if (narratives.children[1].children[7]) {
					narratives.children[1].children[7].color = right3;
				}
				// "Creepy Joe"
				if (narratives.children[1].children[8]) {
					narratives.children[1].children[8].color = right4;
				}
				// "Bumbling"
				if (narratives.children[1].children[9]) {
					narratives.children[1].children[9].color = right5;
				}
			}
			// Guns
			if (narratives.children[2]) {
				narratives.children[2].color = {
					// 1
					id: "Cornflower",
					dark: "#66a4ff",
					light: vars.seafoam_1,
					colorblind: "colorblindBroken",
					inUse: 0,
				};
				// "Gun crisis"
				if (narratives.children[2].children[0]) {
					narratives.children[2].children[0].color = left2;
				}
				// "Guns violate other rights"
				if (narratives.children[2].children[1]) {
					narratives.children[2].children[1].color = left3;
				}
				// "Gun lobby (gun nuts)"
				if (narratives.children[2].children[2]) {
					narratives.children[2].children[2].color = left1;
				}
				// "Gun contol needed (and works)"
				if (narratives.children[2].children[3]) {
					narratives.children[2].children[3].color = left4;
				}
				// "Gun rights"
				if (narratives.children[2].children[4]) {
					narratives.children[2].children[4].color = right1;
				}
				// "People kill people"
				if (narratives.children[2].children[5]) {
					narratives.children[2].children[5].color = right2;
				}
				// "Guns ensure freedom"
				if (narratives.children[2].children[6]) {
					narratives.children[2].children[6].color = right3;
				}
				// "Gun control ineffective"
				if (narratives.children[2].children[7]) {
					narratives.children[2].children[7].color = right4;
				}
			}
			// Taxes
			if (narratives.children[3]) {
				narratives.children[3].color = {
					id: "Uranian_Blue",
					dark: "#b3f3fc", // off white
					light: vars.seaGreen_3,
					colorblind: false,
					inUse: 0,
				};
				// "Taxes too regressive/cuts benefit rich"
				if (narratives.children[3].children[0]) {
					narratives.children[3].children[0].color = left1;
				}
				// "Taxes support services"
				if (narratives.children[3].children[1]) {
					narratives.children[3].children[1].color = left2;
				}
				// "Taxes support services"
				if (narratives.children[3].children[2]) {
					narratives.children[3].children[2].color = right1;
				}
				// "Taxes harm workers"
				if (narratives.children[3].children[3]) {
					narratives.children[3].children[3].color = right2;
				}
				// "Taxes fuel corruption/undermine society"
				if (narratives.children[3].children[4]) {
					narratives.children[3].children[4].color = right3;
				}
			}
			// Abortion
			if (narratives.children[4]) {
				narratives.children[4].color = {
					id: "Seafoam",
					dark: "#1cce99",
					light: vars.lime_4,
					colorblind: "colorblindDots",
					inUse: 0,
				};
				// "Women have the right to decide"
				if (narratives.children[4].children[0]) {
					narratives.children[4].children[0].color = left1;
				}
				// "Abortion rights are threatened"
				if (narratives.children[4].children[1]) {
					narratives.children[4].children[1].color = left2;
				}
				// "Abortion for health of women"
				if (narratives.children[4].children[2]) {
					narratives.children[4].children[2].color = left3;
				}
				// "Unborn have rights"
				if (narratives.children[4].children[3]) {
					narratives.children[4].children[3].color = right1;
				}
				// "Abortion is or should be a crime"
				if (narratives.children[4].children[4]) {
					narratives.children[4].children[4].color = right2;
				}
				// "Objectors are violated"
				if (narratives.children[4].children[5]) {
					narratives.children[4].children[5].color = right3;
				}
			}
			// The Media
			if (narratives.children[5]) {
				narratives.children[5].color = {
					id: "Grass",
					dark: "#32C402",
					light: vars.chartreuse_2,
					colorblind: "colorblindTinyDots",
					inUse: 0,
				};
				// "Media supports truth & has integrity"
				if (narratives.children[5].children[0]) {
					// prevent lightUI conflict with left/right scheme
					narratives.children[5].children[0].color.light = vars.plum_1;
				}
				// "Press freedom is necessary/under-attack"
				if (narratives.children[5].children[1]) {
					narratives.children[5].children[1].color.light = vars.purple_2;
				}
				// 	// "Media preserves democracy"
				// 	if (narratives.children[5].children[2]) {
				// 		narratives.children[5].children[2].color = left3;
				// 	}
				// 	// "Media is biased"
				// 	if (narratives.children[5].children[3]) {
				// 		narratives.children[5].children[3].color = right1;
				// 	}
				// "Media & media standards are declining"
				if (narratives.children[5].children[4]) {
					narratives.children[5].children[4].color.light = "#86c419";
				}
				// 	// "Media is dishonest"
				// 	if (narratives.children[5].children[5]) {
				// 		narratives.children[5].children[5].color = right3;
				// 	}
				// 	// "Media undermining US/Controls Americans"
				// 	if (narratives.children[5].children[6]) {
				// 		narratives.children[5].children[6].color = right4;
				// 	}
			}
			// The Environment
			if (narratives.children[6]) {
				narratives.children[6].color = {
					// 5
					id: "Chartreuse",
					dark: "#C2EB3C",
					light: vars.yellow_3,
					colorblind: "colorblindStripes",
					inUse: 0,
				};
				narratives.children[6].color.light = vars.yellow_3;
				// "Humans are destructive"
				if (narratives.children[6].children[0]) {
					narratives.children[6].children[0].color = left1;
				}
				// "Earth is fragile/resources finite"
				if (narratives.children[6].children[1]) {
					narratives.children[6].children[1].color = left2;
				}
				// "Collective stewardship required"
				if (narratives.children[6].children[2]) {
					narratives.children[6].children[2].color = left3;
				}
				// "Green economy"
				if (narratives.children[6].children[3]) {
					narratives.children[6].children[3].color = left4;
				}
				// "Greed"
				if (narratives.children[6].children[4]) {
					narratives.children[6].children[4].color = left5;
				}
				// "Green policy harms economy"
				if (narratives.children[6].children[5]) {
					narratives.children[6].children[5].color = right2;
				}
				// "Human impact exaggerated/Earth is bountiful"
				if (narratives.children[6].children[6]) {
					narratives.children[6].children[6].color = right3;
				}
				// "Tree huggers"
				if (narratives.children[6].children[7]) {
					narratives.children[6].children[7].color = right4;
				}
			}
			// Trade Policy
			if (narratives.children[7]) {
				narratives.children[7].color = {
					// 6
					id: "Light_Yellow",
					dark: "#F0FCAC",
					light: vars.persimmon_1,
					colorblind: "colorblindBig",
					inUse: 0,
				};
				// 	// "Protectionism harmful"
				// 	if (narratives.children[7].children[0]) {
				// 		narratives.children[7].children[0].color = left1;
				// 	}
				// 	// "Trade benefits economy"
				// 	if (narratives.children[7].children[1]) {
				// 		narratives.children[7].children[1].color = left2;
				// 	}
				// 	// "Access to markets"
				// 	if (narratives.children[7].children[2]) {
				// 		narratives.children[7].children[2].color = left3;
				// 	}
				// 	// "Countries taking advantage/free trade not fair"
				// 	if (narratives.children[7].children[3]) {
				// 		narratives.children[7].children[3].color = right1;
				// 	}
				// 	// "Trade harms workers/only benefits few"
				// 	if (narratives.children[7].children[4]) {
				// 		narratives.children[7].children[4].color = right2;
				// 	}
			}
			// Immigration
			if (narratives.children[8]) {
				narratives.children[8].color = {
					dark: "#CEBF09",
					light: vars.right_4,
					colorblind: "colorblindSmall",
					inUse: 0,
				};
				// "Nation of immigrants"
				if (narratives.children[8].children[0]) {
					narratives.children[8].children[0].color = left1;
				}
				// "Immigrants contribute"
				if (narratives.children[8].children[1]) {
					narratives.children[8].children[1].color = left2;
				}
				// "Immigrants are innocent/seeking betterment"
				if (narratives.children[8].children[2]) {
					narratives.children[8].children[2].color = left3;
				}
				// "Immigrants take our resources"
				if (narratives.children[8].children[3]) {
					narratives.children[8].children[3].color = right1;
				}
				// "Immigrants undermine law and order"
				if (narratives.children[8].children[4]) {
					narratives.children[8].children[4].color = right2;
				}
			}
			// The Economy
			if (narratives.children[9]) {
				narratives.children[9].color = {
					id: "Orange",
					dark: "#ce9309", //
					light: vars.plum_1,
					colorblind: "colorblindGaps",
					inUse: 0,
				};
				// "Bad Economy" - prevent blue
				if (narratives.children[9].children[0]) {
					narratives.children[9].children[0].color = colors[7];
					narratives.children[9].children[2].color.light = "#007005";
				}
				// "Economy benefiting few"
				if (narratives.children[9].children[1]) {
					narratives.children[9].children[1].color = left2;
				}
				// "Good Economy"
				if (narratives.children[9].children[2]) {
					narratives.children[9].children[2].color = colors[6];
					narratives.children[9].children[2].color.light = "#86c419";
				}
				// "Rising Tide"
				if (narratives.children[9].children[3]) {
					narratives.children[9].children[3].color = right3;
				}
			}
			// Border Security
			if (narratives.children[10]) {
				narratives.children[10].color = {
					// 10
					id: "royalBlue",
					dark: vars.persimmon_1,
					light: vars.purple_2,
					colorblind: "colorblindTiny",
					inUse: 0,
				};
				// "Border security as waste"
				if (narratives.children[10].children[0]) {
					narratives.children[10].children[0].color = left1;
				}
				// "Border security is discriminatory"
				if (narratives.children[10].children[1]) {
					narratives.children[10].children[1].color = left2;
				}
				// "Immigrants benefit US"
				if (narratives.children[10].children[2]) {
					narratives.children[10].children[2].color = left3;
				}
				// "Border security is a crisis"
				if (narratives.children[10].children[3]) {
					narratives.children[10].children[3].color = right1;
				}
				// "Immigrants undermine law & order"
				if (narratives.children[10].children[4]) {
					narratives.children[10].children[4].color = right2;
				}
				// "Immigrants take resources"
				if (narratives.children[10].children[5]) {
					narratives.children[10].children[5].color = right3;
				}
			}
			// Health Insurance
			if (narratives.children[11]) {
				narratives.children[11].color = {
					id: "lilac",
					dark: "#7b4db8", // Warm purple
					light: vars.lilac_1,
					colorblind: "colorblindBig",
					inUse: 0,
				};
				// "Health care is a human right"
				if (narratives.children[11].children[0]) {
					narratives.children[11].children[0].color = left1;
				}
				// "Health care is unaffordable"
				if (narratives.children[11].children[1]) {
					narratives.children[11].children[1].color = left2;
				}
				// "Private health industry prioritizes profit"
				if (narratives.children[11].children[2]) {
					narratives.children[11].children[2].color = left3;
				}
				// "Current system is byzantine"
				if (narratives.children[11].children[3]) {
					narratives.children[11].children[3].color = left4;
				}
				// "Universal health care examples work"
				if (narratives.children[11].children[4]) {
					narratives.children[11].children[4].color = left5;
				}
				// "Current system works for most/people are satisfied"
				if (narratives.children[11].children[5]) {
					narratives.children[11].children[5].color = right1;
				}
				// "Universal health care undermines choice"
				if (narratives.children[11].children[6]) {
					narratives.children[11].children[6].color = right2;
				}
				// "Universal health care costs too much"
				if (narratives.children[11].children[7]) {
					narratives.children[11].children[7].color = right3;
				}
				// "Socialized health care is bad health care"
				if (narratives.children[11].children[8]) {
					narratives.children[11].children[8].color = right4;
				}
			}
			// Coronavirus
			if (narratives.children[12]) {
				narratives.children[12].color = {
					id: "royalBlue",
					dark: vars.lilac_1,
					light: vars.left_1,
					colorblind: "colorblindTiny",
					inUse: 0,
				};
			}
		}

		const noReaction = !!projectConfig[currentProject].noReaction;

		// Flat narratives
		const flatNarratives = [narratives];
		_.each(narratives.children, (nar) => {
			flatNarratives.push(nar);
			_.each(nar.children, (childNar) => {
				flatNarratives.push(childNar);
			});
		});

		// Make a line for each narrative, if the project supports reaction
		const narrativesWithPerspective = noReaction ? flatNarratives : [];
		if (!noReaction) {
			_.each(flatNarratives, (nar) => {
				const sourceNar = JSON.parse(JSON.stringify(nar));
				const audienceNar = JSON.parse(JSON.stringify(nar));
				sourceNar.perspective = "Content";
				audienceNar.perspective = "Reaction";
				narrativesWithPerspective.push(sourceNar);
				narrativesWithPerspective.push(audienceNar);
			});
		}

		const narrativesWithPerspectiveAndSearches = searches
			? [...narrativesWithPerspective, ...searches.children]
			: narrativesWithPerspective;

		// TODO: hook additionalLines up to the API when it's ready
		const additionalLines = [];

		const narrativesHaveGrandchildren = _.find(narratives.children, (trend) => {
			return trend.children && trend.children.length > 0;
		});

		dispatch({
			type: "receiveTrends",
			activeNarrativeData: sharedActiveNarrativeData || narratives, // sharedActiveNarrativeData only exists if loading from shared URL
			aiSupport,
			audienceFilters,
			availableLines: [...narrativesWithPerspectiveAndSearches, ...additionalLines],
			baseMap: currentProject, // currently 'usa', 'texas23', 'afghanistan' or 'iraq'. Not required - 'usa' is default
			baseNarrativeObject: narratives,
			baseTrend: narratives.children[0],
			filters: sourceFilters,
			// Add searches to flatNarratives
			flatNarratives: searches ? [...flatNarratives, ...searches.children] : flatNarratives,
			graphDataTypes: projectConfig[currentProject].graphDataTypes,
			// TODO: Add additional graph tab filters when they're passed from the API
			graphTabFilters: [...sourceFilters, ...audienceFilters],
			moe: moe && moe.children,
			narrativesHaveGrandchildren: !!narrativesHaveGrandchildren,
			searches: searches && searches.children,
			sourceFilters,
			subNarrativesExist: !!subNarrativesExist,
			trends: narratives,

			// This just sets the default state of the toggle
			showEnglishTranslation: !projectConfig[currentProject].defaultOriginalLanguage,

			noReaction: noReaction || !audienceFilters || audienceFilters.length <= 0,

			// Share data
			perspective: sharedActiveNarrativeData ? sharedActiveNarrativeData.perspective : false,

			// TODO: Unmock this - events filters and eventTypes
			eventFilters: sourceFilters[0],
			eventTypes: mockEventTypes.children,
		});
	};
}
